import React, { useEffect, useState } from 'lib/react';
import {
  EVLinearProgress, EVTypography, EVBox, EVGrid,
} from 'lib/components';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import LinearProgressWithLabelStyles from './LinearProgressWithLabelStyles';

function LinearProgressWithLabel(props) {
  const { labels, className } = props;
  const [labelIndex, setLabelIndex] = useState(0);
  const classes = LinearProgressWithLabelStyles();

  useEffect(() => {
    const timer = setInterval(() => {
      setLabelIndex((prevLabelIndex) => (prevLabelIndex >= labels.length - 1 ? prevLabelIndex : prevLabelIndex + 1));
    }, 5000);

    return () => {
      clearInterval(timer);
    };
  }, []);

  return (
    <EVGrid container className={clsx(classes.progressBarContainer, className)}>
      <EVBox className={classes.progressBar}>
        <EVLinearProgress variant="determinate" value={(labelIndex + 1) * (100 / (labels.length + 1))} />
        <EVBox>
          <EVTypography variant="body2" component="div">
            {labels[labelIndex]}
          </EVTypography>
        </EVBox>
      </EVBox>
    </EVGrid>
  );
}

LinearProgressWithLabel.defaultProps = {
  className: '',
};

LinearProgressWithLabel.propTypes = {
  labels: PropTypes.arrayOf(PropTypes.string).isRequired,
  className: PropTypes.string,
};

export default LinearProgressWithLabel;
